module.exports = __webpack_public_path__ + "380abdece9081866db9b2d9a655687b4.MP3";